import LocalStorage from './LocalStorage';
import CookieStorage from './CookieStorage';

export default {
	LocalStorage,
	CookieStorage,
};
